import axios from 'axios';
import store from '../store';

// axios.interceptors.response.use(
//   function(response) { return response; },
//   function(error) {
//       if (error.response) {
//         console.log(error.response);
//         store.commit('showNotification', { text: error.response.data.error, status: 'error' });
//         return Promise.reject(error);
//       }
//   });

const baseUrl = process.env.VUE_APP_ROOT_API;

const state = {
  modelosOcorrencia: [],
};

const getters = {
  // Modelos Ocorrencia
  modelosOcorrencia: state => state.modelosOcorrencia.sort((a,b) => a.Descricao > b.Descricao ? 1 : -1),
  modelosOcorrenciaAtivo: state => state.modelosOcorrencia.filter(m => m.Status.startsWith('A')).sort((a,b) => a.Descricao > b.Descricao ? 1 : -1),
}

const actions = {
  // Modelos Ocorrencia
  async fetchModelosOcorrencia({ commit }) {
    try {
      const response = await axios.get(`${baseUrl}/modelosocorrencias`);
      if (response.data.length) {
        commit('setModelosOcorrencia', response.data);
      } else {
        commit('setModelosOcorrencia', []);
      }
    } catch (error) {
      commit('setModelosOcorrencia', []);
    }
  },
  async fetchModelosOcorrenciaSql({ commit }, args) {
    try {
      const response = await axios.get(`${baseUrl}/modelosocorrencias?idLayoutSql=${args.idLayoutSql}`);
      if (response.data.length) {
        commit('setModelosOcorrencia', response.data);
      } else {
        commit('setModelosOcorrencia', []);
      }
    } catch (error) {
      commit('setModelosOcorrencia', []);
    }
  },
  async addModeloOcorrencia({ commit }, modeloOcorrencia) {
    const response = await axios.post(`${baseUrl}/modelosocorrencias`, modeloOcorrencia);
    modeloOcorrencia.IdModeloOcorrencia = response.data.IdModeloOcorrencia;
    commit('newModeloOcorrencia', modeloOcorrencia);
    return response.data.IdModeloOcorrencia;
  },
  async updateModeloOcorrencia({ commit }, updModeloOcorrencia) {
    await axios.put(`${baseUrl}/modelosocorrencias`, updModeloOcorrencia);
    commit('updateModeloOcorrencia', updModeloOcorrencia);
  },
  async deleteModeloOcorrencia({ commit }, id) {
    await axios.delete(`${baseUrl}/modelosocorrencias/${id}`);
    commit('removeModeloOcorrencia', id);
  },
}

const mutations = {
  // Modelos Ocorrencia
  setModelosOcorrencia: (state, modelosOcorrencia) => state.modelosOcorrencia = modelosOcorrencia,
  newModeloOcorrencia: (state, modeloOcorrencia) => state.modelosOcorrencia.push(modeloOcorrencia),
  removeModeloOcorrencia: (state, id) => state.modelosOcorrencia = state.modelosOcorrencia.filter(modeloOcorrencia => modeloOcorrencia.IdModeloOcorrencia !== id),
  updateModeloOcorrencia: (state, updModeloOcorrencia) => {
    const index = state.modelosOcorrencia.findIndex(modeloOcorrencia => modeloOcorrencia.IdModeloOcorrencia === updModeloOcorrencia.IdModeloOcorrencia);
    if (index !== -1) {
      state.modelosOcorrencia.splice(index, 1, updModeloOcorrencia);
    }
  },
}

export default {
  state,
  getters,
  actions,
  mutations
}